import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
  mutation SendFeedbackMutation($input: SendFeedbackInput!) {
    sendFeedback(input: $input) {
      status
    }
  }
`;

function commit(environment, from, content, callback) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: { from, content },
    },
    onCompleted: (response, errors) => {
      if (errors) {
        callback && callback(errors[0]);
      } else {
        callback && callback(null, response.sendFeedback.status);
      }
    },
    onError: err => {
      callback && callback(err);
    },
  });
}

export default { commit };
